import React from "react";

type Props = {
  showTagline?: boolean;
};

export default function Header({ showTagline = true }: Props) {
  // Sizing (px)
  const BADGE = 72;          // outer white circle (ring size you liked)
  const ICON_BASE = BADGE - 6; // base size before scale (keeps a tiny safety margin)
  const ICON_SCALE = 1.75;   // aggressively zoom the image to counter transparent padding
  const GAP = 14;            // space between badge and text

  return (
    <header style={{ background: "#142a6e" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "20px 16px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: GAP }}>
          <div
            style={{
              width: BADGE,
              height: BADGE,
              background: "white",
              borderRadius: "50%",
              border: "3px solid #ffe37d",
              boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            <img
              src="/CueBoard_Logo.png"
              alt="CueBoard"
              style={{
                width: ICON_BASE,
                height: ICON_BASE,
                objectFit: "contain",
                display: "block",
                transform: `scale(${ICON_SCALE})`,
                transformOrigin: "center",
              }}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
          </div>

          <h1
            style={{
              color: "white",
              margin: 0,
              fontSize: 28,
              lineHeight: 1.1,
              fontWeight: 700,
            }}
          >
            CueBoard
          </h1>
        </div>

        {showTagline && (
          <p
            style={{
              color: "rgba(255,255,255,0.9)",
              marginTop: 8,
              marginBottom: 0,
              marginLeft: BADGE + GAP,
              fontSize: 14,
            }}
          >
            
          </p>
        )}
      </div>
    </header>
  );
}
